<template>
  <div id="forgotpassword-view">
    <section class="">
      <!-- Loader -->
      <div class="d-flex justify-content-center">
        <img
          src="@/assets/site/images/loader.gif"
          v-if="loader === true"
          class="img-fluid loader-width"
          alt
        />
      </div>
      <div class="container" v-if="loader === false">
        <!-- Images -->
        <img
          class=""
          src="@/assets/site/images/chair.png"
          style="width: 25%; position: absolute; right: 70%"
          alt=""
        />
        <img
          class="swing"
          src="@/assets/site/images/chair_2.png"
          style="width: 30%; position: absolute; left: 65%"
          alt=""
        />
        <!-- Reset Password Form -->
        <div class="card" style="border: none !important">
          <h1 class="card-title">
            <img src="@/assets/site/images/grey.png" class="img-fluid" alt="" />
          </h1>
          <h3>Reset Password</h3>
          <form class="card-form">
            <div class="card-input-container username">
              <input
                 :type="passwordVisible ? 'text' : 'password'"
                placeholder="Enter Your New Password"
                v-model="new_password"
                @input="validatePassword('new_password')"
                id="new-password"
                  style="width:90%;margin-right:5px;"

              />
               <span class="password-toggle" @click="togglePasswordVisibility">
                  <i class="fas" :class="passwordVisible ?'fa-eye' :'fa-eye-slash'"></i>
                </span>
              <span class="text-danger" v-if="errors.new_password">
                {{ errors.new_password[0] }}
              </span>
            </div>
            <label for="username">Confirm Password</label>
            <div class="card-input-container username">
              <input
                :type="confirmPasswordVisible ? 'text' : 'password'"
                placeholder="Confirm Password"
                v-model="confirm_password"
                id="confirm_password"
                  style="width:90%;margin-right:5px;"

              />
               <span class="password-toggle" @click="toggleConfirmPasswordVisibility">
                  <i class="fas" :class="confirmPasswordVisible ?'fa-eye' :'fa-eye-slash'"></i>
                </span>
              <span class="text-danger" v-if="errors.confirm_password">{{
                this.errors.confirm_password[0]
              }}</span>
            </div>

            <div class="row">
              <div class="col-8">
                <span class="text-danger">{{ error_msg }}</span>
              </div>
            </div>
            <button @click="resetPassword" type="button" class="card-button">
              Submit
            </button>

            <p style="font-size: 14px">
              Don’t have an account?
              <router-link to="/site/signup"> Sign Up</router-link> |
              <router-link to="/site" exact style="font-size: 14px"
                >Login</router-link
              >
            </p>
            <!-- Your existing Confirm Password field -->
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ResetPasswordView",
  data() {
    return {
      new_password: null,
      confirm_password: null,
      errors: [],
      response_message: null,
      color: "success",
      loader: false,
      passwordVisible: false,
      confirmPasswordVisible:false

    };
  },
  methods: {
     togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    toggleConfirmPasswordVisibility(){
      this.confirmPasswordVisible = !this.confirmPasswordVisible;

    },
    validatePassword(field) {
      let validationStatus = false;
      const minLength = 8;
      const hasUpperCase = /[A-Z]/.test(this[field]);
      const hasLowerCase = /[a-z]/.test(this[field]);
      const hasNumber = /\d/.test(this[field]);
      if (!this[field]?.trim()) {
        this.$set(this.errors, field, ["Password is required."]);
      } else if (
        this[field]?.length < minLength ||
        !hasUpperCase ||
        !hasLowerCase ||
        !hasNumber
      ) {
        this.$set(this.errors, field, [
          "Password must be at least 8 characters and include at least one uppercase letter, one lowercase letter, and one number.",
        ]);
      } else {
        validationStatus = true;
        this.$set(this.errors, field, null);
      }
      return validationStatus;
    },
    resetPassword() {
      const passwordValid = this.validatePassword("new_password");
      if (passwordValid) {
        //Save or update User Details
        this.errors = [];
        this.loader = true;
        var segment_str = window.location.pathname;
        var segment_array = segment_str.split("/");
        var last_segment = segment_array.pop();
        let apiUrl = process.env.VUE_APP_URL + "api/resetPassword";
        let method_type = "post";
        fetch(apiUrl, {
          method: method_type,
          headers: {
            "content-type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            token: last_segment,
            new_password: this.new_password,
            confirm_password: this.confirm_password,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.status === true) {
              this.color = "success";
              this.response_message = data.message;
              this.current_password = null;
              this.new_password = null;
              this.confirm_password = null;
            } else if (data.status === false) {
              this.color = "danger";
              this.response_message = data.message;
            } else {
              this.errors = data.errors;
              this.response_message = null;
            }
            this.loader = false;
          })
          .catch(function(err) {
            console.log("Data", "Error : " + err.message, "error");
          });
      }
    },
  },
};
</script>

